import React from "react";

import { EventsContainer, Col, Row, Link } from "./index.style";
import { Container, Title } from "../index.style";
import PlaceHolder from "../../../images/hiring-events.png";

const HiringEvents = () => {
  return (
    <EventsContainer>
      <Container>
        <Row>
          <Col className="col">
            <img src={PlaceHolder} alt="Hiring Events" />
          </Col>
          <Col className="col hiring">
            <Title>QuirkyCoders Hiring Events</Title>
            <p>
              Instead of sifting through resumes, save time and money by
              interviewing candidates face-to-face. Post your event on
              QuirkyCoders and Hiring Events will deliver candidates to your
              door, so you can focus on hiring.
            </p>

            <Link href="/contact-us">Learn more about QuirkyCoders Hiring Events</Link>
          </Col>
        </Row>
      </Container>
    </EventsContainer>
  );
};

export default HiringEvents;
